export default {"src":"/_next/static/media/snt.6cf04f13.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};